var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiLayoutFooter',[_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(_vm.$t('bi.footer.copyright'))+" ")]),_c('template',{slot:"extra"},[_c('BButtonModalPartners')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }